var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"padding-vertical-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"matches"},[_vm._l((_vm.eventos),function(event){return [_c('EventoClub',{key:event.id,attrs:{"productos":_vm.productos,"event":event}})]})],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }